import { Instance } from 'mobx-state-tree';
import { SuggestionDtoModelBase } from './SuggestionDtoModel.base';

/* The TypeScript type of an instance of SuggestionDtoModel */
export interface SuggestionDtoModelType extends Instance<typeof SuggestionDtoModel.Type> {}

/* A graphql query fragment builders for SuggestionDtoModel */
export { selectFromSuggestionDto, suggestionDtoModelPrimitives, SuggestionDtoModelSelector } from './SuggestionDtoModel.base';

/**
 * SuggestionDtoModel
 */
export const SuggestionDtoModel = SuggestionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
